'use strict';
const angular = require('angular');
export class ReviewComponent {
    modalData: any;
    reviewSections: any = [];
    modalInstance: any;
    resolve: any;
    summary:boolean=false;
    ngNotification: any;
    isValid:boolean= true;
    totalSearchable = 0;
    reviewSecArr :any = [
        {
            sectionTitle: '',
            sectionSearchable:false,
            sectionWeightage: 0,
            questions: [{
                reviewquestion: '',
                reviewoptions: ['rating', 'yes-no'],
                reviewanswer: '',
                showComment:false
            }]
        }
    ]
    constructor(localStorage, $http, $filter, Notification, $uibModal, $document, Util, $window, $translate, $rootScope, config, $scope, $sce, $timeout) {
        this.ngNotification = Notification;
    }

    $onInit = function() {
       if (this.resolve.modalData.config.sectionAvailibility && this.resolve.modalData.config.sectionAvailibility.components) {
        this.hideORITitle();
        }
    if (this.resolve.modalData.selectedView.view.controls.A && this.resolve.modalData.selectedView.view.controls.A.length > 1) {
        let existingSecs = this.getExistingSections(this.resolve.modalData.selectedView.view.controls.A);
        if(!this.resolve.modalData.hasOwnProperty('summary')) {
            this.resolve.modalData.summary = this.resolve.modalData.selectedView.view.controls.A.some((element:any) => {
                const fieldName = element['properties']['Basic']['Field Name'].selectedValue;
                return fieldName === 'DescriptionTextarea0';
            });
        }

        this.resolve.modalData.summary && (this.summary = this.resolve.modalData.summary);

        if (existingSecs.length > 0) {
            for (let i = 0; i < existingSecs.length; i++) {
                let questionSections = this.getExistingSections(existingSecs[i].data.elems[0], 'Question_Section'), questionList = [];
                for (let j = 0; j < questionSections.length; j++) {
                    questionList.push(this.getQuestionSection(questionSections[j]));
                }
                let sectitle = existingSecs[i].data.elems[0][0].data[0].elems[0][0].properties['Basic'];
                let secSearch = existingSecs[i].data.elems[0][0].data[1].elems[0][1];
                let sectionObj = {
                    sectionTitle: sectitle['Text'] ? sectitle['Text'].selectedValue: sectitle['Label'].selectedValue,
                    sectionWeightage: existingSecs[i].data.elems[0][0].data[1].elems[0][0].properties['Basic'].Value.selectedValue,
                    sectionSearchable: false,
                    questions: questionList
                }
                if(secSearch) {
                   let secSearchVal =  secSearch.properties['Data Source'].table.list[0].Default.name;
                   sectionObj.sectionSearchable = secSearchVal;
                   if(sectionObj.sectionSearchable && sectionObj.sectionSearchable) {
                    this.totalSearchable = this.totalSearchable + 1;
                   }
                }
                this.reviewSections.push(sectionObj);
            }
        } else {
            this.reviewSections = this.reviewSecArr;
        }
    } else {
        this.reviewSections = this.reviewSecArr;
    }
    };
    hideORITitle() {
        let oriControl = this.resolve.modalData.selectedView.view.controls.A[0];
        oriControl.properties['Display']['Hidden'].selectedValue = true;
    }

    save(myForm) {
        if (myForm.$invalid) {
            this.isValid = false;
            return;
        }
        this.isValid = true;
        let isEmoji: boolean = false;
        let weightage = 0;
        let controlLength = this.resolve.modalData.selectedView.view.controls.A.length;
        let selectedItems = this.resolve.modalData.selectedView.view.controls.A;
        let existingSecs = this.getExistingSections(this.resolve.modalData.selectedView.view.controls.A);
        
        for (let k = 0; k < this.reviewSections.length; k++) {
            isEmoji = this.validateForEmojies(this.reviewSections[k].sectionTitle)
            if(isEmoji) {
                return;
            }
            if(this.reviewSections[k].questions.length) {
                for(let question of this.reviewSections[k].questions) {
                    isEmoji  =this.validateForEmojies(question.reviewquestion);
                    if(isEmoji) {
                        return;
                    }
                }
            }

            if (+this.reviewSections[k].sectionWeightage != 0) {
                weightage = weightage + +this.reviewSections[k].sectionWeightage;
            } else {
                this.ngNotification.error({ message: 'Weightage is mandatory.', positionX: 'center', replaceMessage: true });
                return;
            }
        }
        if (+weightage.toFixed(2) === 1.00) {
            if (existingSecs.length > 0 && this.reviewSections.length > 0) {
                selectedItems.splice(1, controlLength - 1);
            }
            let reviewOrgField = this.getControl(0, 'Review For:', 'Display field', null, 'Reviewee_Org_Name');
            reviewOrgField.properties['Basic']['DSName'].selectedValue = 'DS_ASI_SPMREVIEWEEORGID';
            reviewOrgField.properties['Basic']['Value'].selectedValue = '{{DS_ASI_SPMREVIEWEEORGID}}';
            reviewOrgField.properties['Style']['font-style-group'].members['font-size'].selectedValue = 14;
            reviewOrgField.properties['Style']['style-group'].members['bold'].selectedValue = false;
            reviewOrgField.properties['ControlStyle']['font-style-group'].members['font-size'].selectedValue = 14;
            reviewOrgField.properties['ControlStyle']['style-group'].members['bold'].selectedValue = false;
            selectedItems.push(reviewOrgField);
            for (let i = 0; i < this.reviewSections.length; i++) {
                weightage = weightage + this.reviewSections[i].sectionWeightage;

                let sectionField = this.getSections(this.reviewSections[i], i);
                selectedItems.push(sectionField);
            }
            let summaryField = this.getControl(0, 'Summary', 'Text-Area', '', 'DescriptionTextarea');
            let summaryAttachmentField = this.getControl(0, '', 'Attachment', '', 'DescriptionAddFiles');
            if (this.summary) {
                selectedItems.push(summaryField);
                selectedItems.push(summaryAttachmentField);
            }
            let approversComment = this.getControl('', 'Review Comment (only visible when approving/rejecting reviews)', 'Text-Area', '', 'approversComment');
            approversComment.properties['Display']['Hidden'].selectedValue = true;
            selectedItems.push(approversComment);
            this.resolve.modalData.globleScript = {
                "scriptVal": " window.console && window.console.log && window.console.log(( window.getSystemFieldValue && window.getSystemFieldValue('DS_SPM_TEMPLATE_DETAILS') ));\n",
                "xmlVal": "<xml xmlns=\"https://developers.google.com/blockly/xml\"><block type=\"text_console\" id=\"5CRL8DMCK%Zfm(bHjun]\" x=\"29\" y=\"149\"><value name=\"TEXT\"><shadow type=\"text\" id=\"G{-4B_k[#a%:H`*t8$Bo\"><field name=\"TEXT\">abc</field></shadow><block type=\"sp_value_getter\" id=\"c33oG|/ghhW*%-SMj#yc\"><field name=\"SP_NAME\">DS_SPM_TEMPLATE_DETAILS</field></block></value></block></xml>",
                "systemFields": [
                    "DS_SPM_TEMPLATE_DETAILS"
                ],
                "autoNumberFieldDetail": {},
                "isAPIInProgress": false
            }
            this.resolve.modalData.summary = this.summary;
            this.modalInstance.close(this.reviewSections);
        } else {
            this.ngNotification.error({ message: 'Total weightage should be 1', positionX: 'center', replaceMessage: true });
        }
    };

    validateForEmojies(str) {
        let regexToFindEmoji = new RegExp('[\\u{1F600}-\\u{1F64F}\\u{2700}-\\u{27BF}\\u{1F680}-\\u{1F6FF}\\u{24C2}-\\u{1F251}\\u{1F30D}-\\u{1F567}\\u{1F900}-\\u{1F9FF}\\u{1F300}-\\u{1F5FF}]', 'gu');
        if(regexToFindEmoji.test(str)) {
            this.ngNotification.error({ message: 'Emojis not allowed!', positionX: 'center', replaceMessage: true });
            return true;
        }
        return false;
    }

    selectSearch(sectionData) {
        if (sectionData.sectionSearchable) {
            this.totalSearchable = this.totalSearchable + 1;
        } else {
            this.totalSearchable = this.totalSearchable - 1;
        }
        if (this.totalSearchable > 2) {
            sectionData.sectionSearchable = false;
            this.totalSearchable = this.totalSearchable - 1;
            this.ngNotification.primary({ 
                message: "Max 2 section can be set as 'Searchable'. Please de-select one to select this section.",
                positionX: 'center', 
                replaceMessage: true 
            });
        }
    }
    getWeightage(sections) {
        let weightage = 0;
        for (let i = 0; i < sections.length; i++) {
            let weigthVal = sections[i].data.elems[0][0].data[1].elems[0][0].properties['Basic'].Value.selectedValue;
            weightage = parseFloat(weigthVal) + weightage;
        }
        return weightage;

    }
    getExistingSections(controls, questionSecStr?) {
        let sectionStr = questionSecStr ? questionSecStr : 'Review_Section';
        let filteredControls = controls.filter(sec => sec.type == 'Section');
        let sections = filteredControls.filter(ctrl => (ctrl.properties.Basic['Field Name'].selectedValue).indexOf(sectionStr) != -1);
        return sections;
    }

    getSections(section, idx) {
        let sectionItm = this.getControl(idx, section.sectionTitle, 'Section', '', 'Review_Section');
        let sectionItmTitle = this.getControl(idx, section.sectionTitle, 'Display field', '', 'Section_Title');
        let sectionItmLayout = this.getControl(idx, section.sectionTitle, 'Layout', '', 'Section_Layout');
        let sectionWeightage = this.getControl(idx, section.sectionTitle, 'Textbox', '', 'Section_Weightage');
        sectionWeightage.properties['Basic'].Value.selectedValue = section.sectionWeightage;
        sectionWeightage.properties['Display']['Read-only'].selectedValue = true;
        sectionWeightage.properties['Basic']['Validate'].selectedValue = "Decimal";
        sectionWeightage.properties.Basic.Required.selectedValue = true;
        sectionWeightage.properties['Display']['Hidden'].selectedValue = true; // Hiding the section weightage 
        sectionWeightage.properties['Basic']['Label'].selectedValue = 'Weightage';
        
        let sectionSearchable = this.getControl(idx, section.sectionTitle, 'Checkbox', '', 'Section_Searchable');
        if(section.sectionSearchable) {
            sectionSearchable.properties['Data Source'].table.list[0].Default.name = section.sectionSearchable;
            sectionSearchable.properties['Data Source'].table.list[0].selectedValue.name = section.sectionSearchable;
        }
        sectionSearchable.properties['Display']['Hidden'].selectedValue = true;
        
        sectionItmLayout.data[0].elems[0].push(sectionItmTitle);
        sectionItmLayout.data[1].elems[0].push(sectionWeightage);
        sectionItmLayout.data[1].elems[0].push(sectionSearchable);
        sectionItm.data.elems[0].push(sectionItmLayout);
        let lineItem = angular.copy(this.resolve.modalData.models.items.filter(function (val) { return val.type == "Line" })[0]);
        sectionItm.data.elems[0].push(lineItem);
        if (section.questions.length && section.questions.length > 0) {
            for (let j = 0; j < section.questions.length; j++) {
                let questionItem = this.getQuestions(section.questions[j], idx, j);
                sectionItm.data.elems[0].push(questionItem);
            }
        }

        return sectionItm;
    }

    getQuestionSection(question) {
        let questionControl = question.data.elems[0][0].data[0].elems[0][0];        
        let questionObj = {
            reviewquestion: questionControl.properties['Basic']['Label'].selectedValue,
            reviewoptions: ['rating', 'yes-no'],
            reviewanswer: questionControl.type == 'Rating' ? 'rating' : 'yes-no',
            showComment:false
        }
        if(question.data.elems[0][0].data[1] && question.data.elems[0][0].data[1].elems[0][0] && question.data.elems[0][0].data[1].elems[0][0].optionsList[0][0]["Value"].name === 'addComment') {
            questionObj.showComment = true;
        }

        if(question.data.elems[0][1].type === 'Layout' && question.data.elems[0][1].data.length === 4 && question.data.elems[0][1].data[3].elems[0]) {
            questionObj.showComment = true;
        }
        return questionObj;
    }

    getQuestions(question, idx, j) {
        let questionTitle = question.reviewquestion;
        let questionItem = this.getControl(idx, questionTitle, 'Section', j, 'Question_Section');
        let layoutItem = this.getControl(idx, questionTitle, 'Layout', j, 'Question_Layout');
        let ratingCommentLayout = this.getControl(idx, questionTitle, 'Layout', j, 'rating_comment_layout');
        let radioItem = this.getControl(idx, questionTitle, 'Radio', j, 'Question');
        let ratingItem = this.getControl(idx, questionTitle, 'Rating', j, 'Question');
        let addCommentCheckboxItem = this.getControl(idx, 'Add_Comment', 'Checkbox', j, 'Add_Comment');
        let textAreaItem = this.getControl(idx, 'Comment', 'Text-Area', j, 'Comments');
        let attachmentItem = this.getControl(idx, 'Attachment', 'Attachment', j, 'Attachment');
        let checkboxItem = this.getControl(idx, questionTitle, 'Checkbox', j, 'Weightage_Not_Applicable');
        let lineItem = angular.copy(this.resolve.modalData.models.items.filter(function (val) { return val.type == "Line" })[0]);

        if (question.reviewanswer == 'yes-no') {
            layoutItem.data[0].elems[0].push(radioItem);
            if(question.showComment) {
                layoutItem.data[1].elems[0].push(addCommentCheckboxItem);
            }
        } else if(question.showComment && question.reviewanswer === 'rating') {
            layoutItem.data[0].elems[0].push(ratingItem);
            ratingCommentLayout.data[0].elems[0].push(checkboxItem);
            ratingCommentLayout.data[3].elems[0].push(addCommentCheckboxItem);
        } else {
            layoutItem.data[0].elems[0].push(ratingItem);
            layoutItem.data[1].elems[0].push(checkboxItem);
        }
        questionItem.data.elems[0].push(layoutItem);
        question.showComment && question.reviewanswer === 'rating' && questionItem.data.elems[0].push(ratingCommentLayout);
        question.showComment && questionItem.data.elems[0].push(textAreaItem);
        question.showComment && questionItem.data.elems[0].push(attachmentItem);
        questionItem.data.elems[0].push(lineItem);
        return questionItem;
    }
    getControl(idx, title, type, questionIndex?, fieldName?) {
        if (questionIndex >= 0 && questionIndex != '') {
            idx = idx + '_' + questionIndex;
        }
        switch (type) {
            case 'Section':
                let sectionControl = angular.copy(this.resolve.modalData.models.items.filter(function (val) { return val.type == type })[0]);
                if (sectionControl && sectionControl.properties) {
                    sectionControl.properties['Basic']['Field Name'].selectedValue = fieldName + idx;
                    sectionControl.properties['Basic']['Data Field Name'].selectedValue = fieldName + idx;
                    sectionControl.uid = this.resolve.modalData.Util.getGUID();
                }
                return sectionControl;
            case 'Label':
                let labelControl = angular.copy(this.resolve.modalData.models.items.filter(function (val) { return val.type == type })[0]);
                if (labelControl && labelControl.properties) {
                    labelControl.properties['Basic']['Field Name'].selectedValue = fieldName + idx;
                    labelControl.properties['Basic']['Text'].selectedValue = title;
                    labelControl.uid = this.resolve.modalData.Util.getGUID();
                }
                return labelControl;
            case 'Display field':
                let displayFieldControl = angular.copy(this.resolve.modalData.models.items.filter(function (val) { return val.type == type })[0]);
                if (displayFieldControl && displayFieldControl.properties) {
                    displayFieldControl.properties['Basic']['Field Name'].selectedValue = fieldName + idx;
                    displayFieldControl.properties['Basic']['Label'].selectedValue = title;
                    displayFieldControl.properties['Style']['font-style-group'].members['font-size'].selectedValue = 24;
                    displayFieldControl.properties['Style']['style-group'].members['bold'].selectedValue = true;
                    displayFieldControl.uid = this.resolve.modalData.Util.getGUID();
                }
                return displayFieldControl;
            case 'Layout':
                let layoutControl = angular.copy(this.resolve.modalData.models.items.filter(function (val) { return val.type == type })[0]);
                if (layoutControl && layoutControl.properties) {
                    layoutControl.properties['Basic']['Field Name'].selectedValue = fieldName + idx;
                    layoutControl.width = { 0: '79%' };
                    layoutControl.properties['Display']['Border'].selectedValue = "0px solid #ccc";
                    layoutControl.uid = this.resolve.modalData.Util.getGUID();
                    if(fieldName === "rating_comment_layout") {
                        layoutControl.width = {};
                        layoutControl.data.push({elems: [[]]});
                        layoutControl.data.push({elems: [[]]});
                    }
                }
                return layoutControl;
            case 'Textbox':
                let textboxControl = angular.copy(this.resolve.modalData.models.items.filter(function (val) { return val.type == type })[0]);
                if (textboxControl && textboxControl.properties) {
                    textboxControl.properties['Basic']['Field Name'].selectedValue = fieldName + idx;
                    textboxControl.properties['Basic']['Data Field Name'].selectedValue = fieldName + idx;
                    textboxControl.properties['Basic']['Label'].selectedValue = '';
                    textboxControl.uid = this.resolve.modalData.Util.getGUID();
                }
                return textboxControl;
            
            case 'Radio':
                let radioControl = angular.copy(this.resolve.modalData.models.items.filter(function (val) { return val.type == type })[0]);
                if (radioControl && radioControl.properties) {
                    radioControl.properties['Basic']['Field Name'].selectedValue = fieldName + idx;
                    radioControl.properties['Basic']['Data Field Name'].selectedValue = fieldName + idx;
                    radioControl.properties['Basic']['Number'].selectedValue = 3;
                    radioControl.properties['Basic']['Label'].selectedValue = title;
                    radioControl.properties['Style']['style-group'].members['bold'].selectedValue = true;
                    radioControl.properties['Margin']['margin-right'].selectedValue = 155;
                    radioControl.properties.Basic.Required.selectedValue = true;
                    
                    radioControl.uid = this.resolve.modalData.Util.getGUID();
                    if (questionIndex >= 0) {
                        let optionItem = radioControl.properties['Data Source'].table.list[0];

                        let optionArr = [];
                        for (let i = 0; i <= 2; i++) {
                            let copyItem = angular.copy(optionItem);
                            if (i == 0) {
                                copyItem.Label.name = 'Yes';
                                copyItem.Value.name = 'yes';

                            } else if (i == 1) {
                                copyItem.Label.name = 'No';
                                copyItem.Value.name = 'no';

                            } else if (i == 2) {
                                copyItem.Label.name = 'Not Applicable';
                                copyItem.Value.name = 'na';

                            }
                            optionArr.push(copyItem);
                        }
                        radioControl.properties['Data Source'].table.list = optionArr;
                    }
                }
                return radioControl;
            case 'Checkbox':
                let checkboxControl = angular.copy(this.resolve.modalData.models.items.filter(function (val) { return val.type == type })[0]);
                if (checkboxControl && checkboxControl.properties) {
                    checkboxControl.properties['Basic']['Field Name'].selectedValue = fieldName + idx;
                    checkboxControl.properties['Basic']['Data Field Name'].selectedValue = fieldName + idx;
                    checkboxControl.properties['Basic']['Label'].selectedValue = '';
                    if(fieldName.indexOf('Section_Searchable') >= 0) {
                        let item = checkboxControl.properties['Data Source'].table.list.pop();
                            item.Label.name = 'searchable';
                            item.Value.name = 'searchable';
                            checkboxControl.properties['Data Source'].table.list[0] = item;
                    } 
                    if(fieldName.indexOf('Add_Comment') >= 0) {
                        let item = checkboxControl.properties['Data Source'].table.list.pop();
                            item.Label.name = 'Add Comment';
                            item.Value.name = 'addComment';
                            checkboxControl.properties['Data Source'].table.list[0] = item;
                            let datafieldNameCheckbox = fieldName + idx;
                            let fieldNameTextArea = 'Comments'+ idx;
                            let fieldNameAttachment = 'Attachment'+ idx;
                            checkboxControl.properties.Events.load.name = 'onLoad';
                            checkboxControl.properties.Events.load.selectedValue = "if ( (window.getPropValueByDataFieldName && window.getPropValueByDataFieldName('"+ datafieldNameCheckbox +"', ))  == 'addComment') {   (window.setPropValue && window.setPropValue('"+fieldNameAttachment+"', 'hidden', false, ));   (window.setPropValue && window.setPropValue('"+fieldNameTextArea+"', 'hidden', false, ));} else {   (window.setPropValue && window.setPropValue('"+fieldNameAttachment+"', 'hidden', true, ));   (window.setPropValue && window.setPropValue('"+fieldNameTextArea+"', 'hidden', true, ));}"
                            
                            checkboxControl.properties.Events.change.name = 'onChange';
                            checkboxControl.properties.Events.change.selectedValue = "if ( (window.getPropValueByDataFieldName && window.getPropValueByDataFieldName('"+ datafieldNameCheckbox +"', ))  == 'addComment') {   (window.setPropValue && window.setPropValue('"+fieldNameAttachment+"', 'hidden', false, ));   (window.setPropValue && window.setPropValue('"+fieldNameTextArea+"', 'hidden', false, ));} else {   (window.setPropValue && window.setPropValue('"+fieldNameAttachment+"', 'hidden', true, ));   (window.setPropValue && window.setPropValue('"+fieldNameTextArea+"', 'hidden', true, )); (window.setPropValueByDataFieldName && window.setPropValueByDataFieldName('"+fieldNameTextArea+"', '','', )); (window.setPropValueByDataFieldName && window.setPropValueByDataFieldName('"+fieldNameAttachment+"', '','', ));}"
                            
                    } 
                    if(fieldName.indexOf('Weightage_Not_Applicable') >= 0) {
                        checkboxControl.properties['Margin']['margin-top'].selectedValue = 0;
                        checkboxControl.properties['Margin']['margin-right'].selectedValue = 3;
    
                        checkboxControl.uid = this.resolve.modalData.Util.getGUID();
                        if (questionIndex >= 0) {
                            let item = checkboxControl.properties['Data Source'].table.list.pop();
                            item.Label.name = 'Not Applicable';
                            item.Value.name = 'na';
                            checkboxControl.properties['Data Source'].table.list[0] = item;
                            let datafieldNameCheckbox = checkboxControl.properties['Basic']['Data Field Name'].selectedValue;
                            let fieldNameRadio = 'Question'+ idx;
                            checkboxControl.properties.Events.change.name = 'onChange';
                            checkboxControl.properties.Events.change.selectedValue = "if ( (window.getPropValueByDataFieldName && window.getPropValueByDataFieldName('"+datafieldNameCheckbox+"', ))  == 'na') {   (window.setPropValue && window.setPropValue('"+fieldNameRadio+"', 'readOnly', true, )); (window.setPropValueByDataFieldName && window.setPropValueByDataFieldName('"+fieldNameRadio+"', 1,'', ));} else {   (window.setPropValue && window.setPropValue('"+fieldNameRadio+"', 'readOnly', false, ));}"
                            checkboxControl.properties.Events.change.name = 'onLoad';
                            checkboxControl.properties.Events.load.selectedValue = "if ( (window.getPropValueByDataFieldName && window.getPropValueByDataFieldName('"+datafieldNameCheckbox+"', ))  == 'na') {   (window.setPropValue && window.setPropValue('"+fieldNameRadio+"', 'readOnly', true, )); (window.setPropValueByDataFieldName && window.setPropValueByDataFieldName('"+fieldNameRadio+"', 1,'', ));} else {   (window.setPropValue && window.setPropValue('"+fieldNameRadio+"', 'readOnly', false, ));}"
                        
                        }
                    }
                }
                return checkboxControl;
            case 'Rating':
                let ratingControl = angular.copy(this.resolve.modalData.models.items.filter(function (val) { return val.type == type })[0]);
                if (ratingControl && ratingControl.properties) {
                    ratingControl.properties['Basic']['Field Name'].selectedValue = fieldName + idx;
                    ratingControl.properties['Basic']['Data Field Name'].selectedValue = fieldName + idx;
                    ratingControl.properties['Basic']['Label'].selectedValue = title;
                    ratingControl.properties['Style']['style-group'].members['bold'].selectedValue = true;
                    ratingControl.properties.Basic.Value.selectedValue = 1;
                    ratingControl.properties.Basic.Min.selectedValue = 1;
                    ratingControl.properties.Basic.Required.selectedValue = true;
                    if(this.resolve.modalData.config && this.resolve.modalData.config.sectionAvailibility.components) {
                        ratingControl.properties.Basic.Max.selectedValue =   this.resolve.modalData.config.formDetail.reviewScale? this.resolve.modalData.config.formDetail.reviewScale : 5;
                    }
                    ratingControl.uid = this.resolve.modalData.Util.getGUID();
                }
                return ratingControl;
            case 'Attachment':
                let attachmentControl = angular.copy(this.resolve.modalData.models.items.filter(function (val) { return val.type == type })[0]);
                if (attachmentControl && attachmentControl.properties) {
                    attachmentControl.properties['Basic']['Field Name'].selectedValue = fieldName + idx;
                    attachmentControl.properties['Basic']['Data Field Name'].selectedValue = fieldName + idx;
                    attachmentControl.properties['Basic']['Label'].selectedValue = '';
                    attachmentControl.uid = this.resolve.modalData.Util.getGUID();
                }
                return attachmentControl;
            case 'Text-Area':
                let textboxAreaControl = angular.copy(this.resolve.modalData.models.items.filter(function (val) { return val.type == type })[0]);
                if (textboxAreaControl && textboxAreaControl.properties) {
                    textboxAreaControl.properties['Basic']['Field Name'].selectedValue = fieldName + idx;
                    textboxAreaControl.properties['Basic']['Data Field Name'].selectedValue = fieldName + idx;
                    textboxAreaControl.properties['Basic']['Label'].selectedValue = title;
                    textboxAreaControl.properties['Style']['style-group'].members['bold'].selectedValue = true;
                    textboxAreaControl.uid = this.resolve.modalData.Util.getGUID();
                }
                return textboxAreaControl;
        }
    }

    cancel() {
        console.info("in handle dismiss");
        this.modalInstance.dismiss("cancel");
    };

    addQuestion(index) {
        this.reviewSections[index].questions.push({
            reviewquestion: '',
            reviewoptions: ['rating', 'yes-no'],
            reviewanswer: '',
            showComment:false
        });
    }
    addReviewSection() {
        this.reviewSections.push({
            sectionTitle: '',
            sectionWeightage: 0,
            sectionSearchable: false,
            questions: [{
                reviewquestion: '',
                reviewoptions: ['rating', 'yes-no'],
                reviewanswer: '',
                showComment:false
            }]
        })
    }

    removeQuestion(secIdx, index) {
        this.reviewSections[secIdx].questions.splice(index, 1);
    }
    removeReviewSection(index) {
        this.reviewSections.splice(index, 1)
    }

    removeInvalidChars(e) {
        if (e.shiftKey === true ) {
            if (e.which == 9) {
                return true;
            }
            e.preventDefault();
            return false;
        }
        if (e.which > 57 || e.which==45 || e.which==43) {
            e.preventDefault();
            return false;
        }
        return true;
    }

    onChangeHandler(section) {
        if(!section.sectionWeightage) {
            return;
        }

        const floatValue = parseFloat(section.sectionWeightage);
        let hasMoreThanTwoDecimals = /\.\d{3,}/.test(section.sectionWeightage);
        if (isNaN(floatValue) || floatValue < 0 || floatValue > 1) {
            section.sectionWeightage =  0;
            return;
        }

        section.sectionWeightage =  hasMoreThanTwoDecimals ? Math.floor(parseFloat(section.sectionWeightage) * 100) / 100 : section.sectionWeightage;

    }
}

export default angular.module('nodeApp.reviewcomponent', [])
    .component('reviewcomponent', {
        template: require('./review.component.html'),
        css: require('./review.component.css'),
        controller: ReviewComponent,
        controllerAs: 'reviewtemplatectrl',
        bindings: {
            modalInstance: "<",
            resolve: "<"
        },
    })
    .name;


// WEBPACK FOOTER //
// ./client/components/reviewComponent/review.component.ts